<script>

  import { menuComputed } from '@store/helpers'

  export default {
    props: {
      type: {
        type: String,
        default: 'breadcrumb',
        validator(value) {
          return [
            'breadcrumb',
            'search',
          ].includes(value)
        },
      },
      data: {
        type: Object,
        default: () => {
          return {
            routeName: 'home'
          }
        }
      }
    },
    computed: {
      ...menuComputed,
      routeName() {
        if(this.type === 'breadcrumb') {
          return this.$route.name
        }
        if(this.type === 'search') {
          return this.data.routeName
        }
      },
      level1Menu() {
        const menuList = this.currentMenu || [];
        return this.getMenuItem(menuList)
      },
      level2Menu() {
        const menuList = this.level1Menu.children || [];
        return this.getMenuItem(menuList)
      },
      level3Menu() {
        const menuList = this.level2Menu.children || [];
        return this.getMenuItem(menuList)
      },
      level4Menu() {
        const menuList = this.level3Menu.children || [];
        return this.getMenuItem(menuList)
      },
      level5Menu() {
        const menuList = this.level4Menu.children || [];
        return this.getMenuItem(menuList)
      },
      level6Menu() {
        const menuList = this.level5Menu.children || [];
        return this.getMenuItem(menuList)
      },
      lastLeval() {
        if(this.level6Menu) {
          return 6;
        }
        if(this.level5Menu) {
          return 5;
        }
        if(this.level4Menu) {
          return 4;
        }
        if(this.level3Menu) {
          return 3;
        }
        if(this.level2Menu) {
          return 2;
        }
        return 1;
      },
    },
    methods: {
      hasActiveMenu(menus) {
        return menus.some(menu => {
          if(menu.alias === this.routeName) {
            return menu.alias === this.routeName
          }

          if(menu.children) {
            return this.hasActiveMenu(menu.children)
          }

          return false
        });
      },
      getMenuItem(menuList) {
        let menuItem = false;

        menuList.forEach(menu => {
          if(menu.alias === this.routeName) {
            menuItem = menu
          }

          if(menu.children) {
            if(this.hasActiveMenu(menu.children)) {
              menuItem = menu
            }
          }
        });

        return menuItem
      },
      getTitle(level) {
        if(this.type === 'breadcrumb') {
          if(this.$route.params[`breadcrumbLevel${ level }Title`]) {
            return this.$route.params[`breadcrumbLevel${ level }Title`]
          } else if(this.lastLeval === level && this.$route.params.breadcrumbTitle) {
            return this.$route.params.breadcrumbTitle
          } else {
            return this[`level${ level }Menu`].title
          }
        }

        if(this.type === 'search') {
          if(this.data[`breadcrumbLevel${ level }Title`]) {
            return this.data[`breadcrumbLevel${ level }Title`]
          } else if(this.lastLeval === level && this.data.breadcrumbTitle) {
            return this.data.breadcrumbTitle
          } else {
            return this[`level${ level }Menu`].title
          }
        }
      },
      getLink(level) {
        if(this.type === 'breadcrumb') {
          return this[`level${ level }Menu`].alias
            ? { name: this[`level${ level }Menu`].alias }
            : undefined
        }

        if(this.type === 'search') {
          return undefined
        }
      },
      checkMenu(level) {
        return this[`level${ level }Menu`]
      },
    },
  }
</script>
<template>
  <div>
    <el-breadcrumb
      separator=">"
      class="baseBreadcrumb"
      :class="[type === 'search' ? 'isStyleSearch' : 'isStyleBase', $style.baseBreadcrumb]"
    >
      <div class="container">
        <el-breadcrumb-item
          :to="type === 'breadcrumb' ? { name: 'home' } : undefined">
          首頁
        </el-breadcrumb-item>
        <template v-for="(n, index) in lastLeval">
          <el-breadcrumb-item
            v-if="checkMenu(n)"
            :to="getLink(n)"
          >
            {{ getTitle(n) }}
          </el-breadcrumb-item>
        </template>
      </div>
    </el-breadcrumb>
  </div>
</template>
<style lang="scss" module>
  .baseBreadcrumb {
    :global {
      .baseBreadcrumb {

      }
    }
  }

  :global {
    .isSearch {
      :local(.baseBreadcrumb) {

      }
    }
  }
</style>
